module.exports = __webpack_public_path__ + "static/media/cloud.6bd3476c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/loader-generating/icons/cloud.png
// module id = 1132
// module chunks = 0